import React, { useEffect } from 'react'

import { DatePickerComponent, Inject, MaskedDateTime } from '@syncfusion/ej2-react-calendars'

import { getMixedProps } from './blockPublic'
import { nullDate } from '../../../utility'
import { useEventHandler, useInstData } from 'tyan/public/hooks'

const FormMonth = ({ config: { field, onChange, initValues, /* changedValues,  */defaultStyle, that: { state: { _validStamp } } } }) => {
	const { me, setState, me: { state: { edited } } } = useInstData()
	const { value: currentValue, name } = field
	const value = Tyan.sysMode === 'sample' && typeof currentvalue === 'string'
		? Tyan.Date.getDate(currentValue)
		: currentValue && currentValue !== nullDate && Tyan.Date.getMonthLocal(currentValue) || null
	// const d = currentValue && currentValue !== nullDate && new Date(currentValue) || null
	// const value = d && new Date(d.getUTCFullYear(), d.getUTCMonth(), 1)

	const handleChange = useEventHandler(({ value: inputValue }) => {
		!me.state.edited && setState({ edited: true })

		const newValue = inputValue ? Tyan.Date.getMonthUtcValue(inputValue) : nullDate
		// const newValue = inputValue ? Date.UTC(inputValue.getFullYear(), inputValue.getMonth(), 1).valueOf() : nullDate
		onChange({ name, newValue: newValue, type: 'date' })
	})

	let { props: { disabled, minDate, min, maxDate, max, clearable, ...props } } = getMixedProps('_date', [defaultStyle, field])
	min = min || minDate
	max = max || maxDate
	min && (props.min = new Date(min.getFullYear(), min.getMonth(), min.getDate()))
	max && (props.max = new Date(max.getFullYear(), max.getMonth(), max.getDate()))

	const doValidate = useEventHandler(() => {
		if (edited || _validStamp) {
			value
				? me.datePicker.inputWrapper.container.classList.remove('e-error')
				: me.datePicker.inputWrapper.container.classList.add('e-error')
		}
	})

	useEffect(() => {
		doValidate()
	})

	const handleBlur = () => {
		doValidate()
	}

	return <DatePickerComponent {...props} ref={ref => me.datePicker = ref} cssClass='t-input-group'
		openOnFocus
		start={'Year'} depth={'Year'}
		// start={'Decade'} depth={'Decade'}
		format='yyyy/MM' enableMask maskPlaceholder={{ year: 'yyyy', month: 'mm' }}
		enabled={!disabled} showClearButton={clearable}
		value={value} change={handleChange} /* focus={handleFocus} */ blur={handleBlur}
	>
		<Inject services={[MaskedDateTime]} />
	</DatePickerComponent>
}

const renderMonth = config => {
	const { key } = config.field || {}
	return <FormMonth key={key} config={config} />
}

export default renderMonth